import type { Model3DDefinition } from "../Model3D";
import type { GlassButtonOptions } from "./ButtonModelParameters";

export const genericTouchButtonModel: Model3DDefinition<GlassButtonOptions> = {
  id: "generic-touch-button", label: "Generischer Touch-Taster",
  load: () => import("./GenericTouchButton").then(module => module.createModel),
};
export const mdtGlassButtonModel: Model3DDefinition<GlassButtonOptions> = {
  id: "mdt-glass-ii-smart", label: "MDT Glastaster II Smart",
  load: () => import("./MDTGlassButton").then(module => module.createModel),
};

/** For adapters and external test selectors, never selected by ModelViewControl itself. */
export const buttonModelCatalog = [genericTouchButtonModel, mdtGlassButtonModel] as const;
